import React from 'react';
import Reveal, { RevealWords } from './Reveal';
import { Starburst } from './Icons';
import './PageHero.css';

/** Compact hero used by every page except Home. */
export default function PageHero({ eyebrow, title, lead, image, align = 'left', children }) {
  return (
    <header className={`phero phero--${align}`}>
      <div className="phero__bg" aria-hidden="true">
        {image ? <img src={image} alt="" loading="eager" /> : null}
      </div>

      <div className="page phero__inner on-dark">
        <Reveal className="phero__mark" delay={0.05}>
          <Starburst size={44} />
        </Reveal>
        {eyebrow ? (
          <Reveal as="p" className={`eyebrow${align === 'center' ? ' is-centered' : ''}`} delay={0.1}>
            {eyebrow}
          </Reveal>
        ) : null}
        <h1 className="display brand d1 phero__title">
          <RevealWords text={title} />
        </h1>
        {lead ? (
          <Reveal as="p" className="lead phero__lead" delay={0.35}>
            {lead}
          </Reveal>
        ) : null}
        {children ? (
          <Reveal className="phero__actions" delay={0.45}>
            {children}
          </Reveal>
        ) : null}
      </div>
    </header>
  );
}
